<div class="spinner-border text-dark" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
